import { Session } from './Session';
import { getTeacherSuffix } from '../../src_server/entity/master/buildingData';

export function getTeacherSuffixInSession() {
  const building = Session.getSessionBuildingId();
  return getTeacherSuffix(building);
}
